import { API_ENDPOINTS } from "@/services/api/endpoints";

/**
 * Endpoint that feeds the "Tenant" dropdown of the institution form.
 *
 * The request said `/api/v1/institutions?page_size=100&status=active`, which can only
 * be a typo because the dropdown lists tenants. To use that instead, change this one
 * line to `API_ENDPOINTS.INSTITUTIONS.LIST`.
 *
 * This is the ONLY place in the institutions feature allowed to reference
 * `API_ENDPOINTS.TENANTS` (see institutions.isolation.test.ts).
 */
export const TENANT_LOOKUP_ENDPOINT = API_ENDPOINTS.TENANTS.LIST;

/**
 * Max number of tenants requested for the dropdown. Only the first
 * TENANT_LOOKUP_LIMIT active tenants are listed (the user can type to filter
 * within those); tenants beyond that are not selectable here.
 */
export const TENANT_LOOKUP_LIMIT = 100;

export const TENANT_LOOKUP_PARAMS = {
  page_size: TENANT_LOOKUP_LIMIT,
  status: "active",
} as const;
